import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
} from "vue-router";
// import Login from "../views/Login.vue";
// import LoginGraphPassword from "../views/LoginGraphPassword.vue";
// import LoginAccountActivated from "../views/LoginAccountActivated.vue";
// import LoginFindPassword from "../views/LoginFindPassword.vue";
// import LoginAcctSetSuccess from "../views/LoginAcctSetSuccess.vue";
// import Welcome from "../views/Welcome.vue";
// import ParentsLogin from "../views/ParentsLogin.vue";
// import ParentsSetPassword from "../views/ParentsSetPassword.vue";
// import ParentsFindPassword from "../views/ParentsFindPassword.vue";
// import Parents from "../views/Parents.vue";
// import ParentsUiStudyStats from "../views/ParentsUiStudyStats.vue";
// import ParentsUiStdAccount from "../views/ParentsUiStdAccount.vue";
// import ParentsUiHistory from "../views/ParentsUiHistory.vue";
// import ParentsUiAward from "../views/ParentsUiAward.vue";
import Home from "../views/Home.vue";
import HomePage from "../views/HomePage.vue";

// import MyAward from "../views/MyAward.vue";
// import MyAwardGacha from "../views/MyAwardGacha.vue";
// import MyTitle from "../views/MyTitle.vue";
// import MyAchievement from "../views/MyAchievement.vue";
// import MyDictionary from "../views/MyDictionary.vue";
// import DailyGoal from "../views/DailyGoal.vue";
// import DailyLogin from "../views/DailyLogin.vue";
// import Challenges from "../views/Challenges.vue";
// import ChallengesOral from "../views/ChallengesOral.vue";
// import ChallengesOralResult from "../views/ChallengesOralResult.vue";
// import Homework from "../views/Homework.vue";
// import HomeworkDetail from "../views/HomeworkDetail.vue";
// import CourseMaterialsBook from "../views/CourseMaterialsBook.vue";
// import CourseMaterialsVideo from "../views/CourseMaterialsVideo.vue";
// import CourseMaterialsOral from "../views/CourseMaterialsOral.vue";
// import BookMark from "../views/BookMark.vue";
// import BookDictionary from "../views/BookDictionary.vue";
// import BookReading from "../views/BookReading.vue";
// import Quiz from "../views/Quiz.vue";
// import QuizResult from "../views/QuizResult.vue";
// import Class from "../views/Class.vue";
// import ClassPage from "../views/ClassPage.vue";
// import ClassBookPage from "../views/ClassBookPage.vue";
// import ClassVideoPage from "../views/ClassVideoPage.vue";
// import LevelCheck from "../views/LevelCheck.vue";
// import ErrorPage from "../views/404.vue";
import { useGlobalStore } from "../store/modules/global";
import GachaPrize from "@/views/GachaPrize.vue";
import EnglishCentralPage from "@/views/EnglishCentralPage.vue";
import DisclaimerPage from "@/components/Modal/DisclaimerModal.vue";
import CapsuleToyLand from "@/views/CapsuleToyLand.vue";
import JoinClass from "@/views/JoinClass.vue";

const Login = () => import("../views/Login.vue");
const LoginSSO = () => import("../views/LoginSSO.vue");
const LoginGraphPassword = () => import("../views/LoginGraphPassword.vue");
const LoginAccountActivated = () =>
  import("../views/LoginAccountActivated.vue");
const LoginFindPassword = () => import("../views/LoginFindPassword.vue");
const LoginAcctSetSuccess = () => import("../views/LoginAcctSetSuccess.vue");
const Welcome = () => import("../views/Welcome.vue");
const ParentsLogin = () => import("../views/ParentsLogin.vue");
const ParentsSetPassword = () => import("../views/ParentsSetPassword.vue");
const ParentsFindPassword = () => import("../views/ParentsFindPassword.vue");
const Parents = () => import("../views/Parents.vue");
const ParentsUiStudyStats = () => import("../views/ParentsUiStudyStats.vue");
const ParentsUiStdAccount = () => import("../views/ParentsUiStdAccount.vue");
const ParentsUiHistory = () => import("../views/ParentsUiHistory.vue");
const ParentsUiAward = () => import("../views/ParentsUiAward.vue");
// const Home = () => import("../views/Home.vue");
// const HomePage = () => import("../views/HomePage.vue");
const MyAward = () => import("../views/MyAward.vue");
const MyAwardGacha = () => import("../views/MyAwardGacha.vue");
const MyTitle = () => import("../views/MyTitle.vue");
const MyAchievement = () => import("../views/MyAchievement.vue");
const MyDictionary = () => import("../views/MyDictionary.vue");
const DailyGoal = () => import("../views/DailyGoal.vue");
const DailyLogin = () => import("../views/DailyLogin.vue");
const Challenges = () => import("../views/Challenges.vue");
const ChallengesOral = () => import("../views/ChallengesOral.vue");
const ChallengesOralResult = () => import("../views/ChallengesOralResult.vue");
const Homework = () => import("../views/Homework.vue");
const HomeworkDetail = () => import("../views/HomeworkDetail.vue");
const CourseMaterialsBook = () => import("../views/CourseMaterialsBook.vue");
const CourseMaterialsVideo = () => import("../views/CourseMaterialsVideo.vue");
const CourseMaterialsOral = () => import("../views/CourseMaterialsOral.vue");
const BookMark = () => import("../views/BookMark.vue");
const BookDictionary = () => import("../views/BookDictionary.vue");
const BookReading = () => import("../views/BookReading.vue");
const Quiz = () => import("../views/Quiz.vue");
const QuizResult = () => import("../views/QuizResult.vue");
const VideoQuiz = () => import("../views/VideoQuiz.vue");
const Class = () => import("../views/Class.vue");
const ClassPage = () => import("../views/ClassPage.vue");
const ClassBookPage = () => import("../views/ClassBookPage.vue");
const ClassVideoPage = () => import("../views/ClassVideoPage.vue");
const LevelCheck = () => import("../views/LevelCheck.vue");
const ErrorPage = () => import("../views/404.vue");
const DailyConversation = () => import("../views/DailyConversation.vue");
const PhrasalVerb = () => import("../views/PhrasalVerb.vue");
const QuizMangosteems = () => import("../views/QuizMangosteems.vue");
const MyTitleList = () => import("../views/MyTitleList.vue");
const AISpeech = () => import("../views/AISpeech.vue");
const AISpeechContent = () => import("../views/AISpeechContent.vue");
const AISpeechContentResult = () =>
  import("../views/AISpeechContentResult.vue");
const AIBonus = () => import("../views/AIBonus.vue");
const PracticeWords = () => import("../views/PracticeWords.vue");
const ParentsResetPassword = () => import("../views/ParentsResetPassword.vue");
const ExcelChatPage = () => import("../views/ExcelChatPage.vue");
const IframeDisplay = () => import("../views/IframeDisplay.vue");
const ReadingHistory = () => import("../views/ReadingHistory.vue");
import AuthAnimation from "@/views/AuthAnimation.vue";
const router = createRouter({
  history: createWebHistory("/v2/"),
  routes: [
    {
      path: "/:catchAll(.*)",
      redirect: "/login",
      component: Login,
    },
    {
      path: "/login",
      name: "Login",
      component: Login,
    },
    {
      path: "/ssologin",
      name: "SSOLogin",
      component: LoginSSO,
    },
    {
      path: "/graph-password/:status",
      name: "GraphPassword",
      component: LoginGraphPassword,
    },
    {
      path: "/welcome",
      name: "Welcome",
      component: Welcome,
    },
    {
      path: "/find-password",
      name: "LoginFindPassword",
      component: LoginFindPassword,
    },
    {
      path: "/account-set-success",
      name: "LoginAcctSetSuccess",
      component: LoginAcctSetSuccess,
    },
    {
      path: "/account-activated",
      name: "LoginAccountActivated",
      component: LoginAccountActivated,
    },
    {
      path: "/coupon/:code?",
      name: "JoinClass",
      component: JoinClass,
      props: true,
    },
    {
      path: "/parents-login/:status",
      name: "ParentsLogin",
      component: ParentsLogin,
    },
    {
      path: "/parents-reset-password",
      name: "ParentsResetPassword",
      component: ParentsResetPassword,
    },
    {
      path: "/parents-find-password",
      name: "ParentsFindPassword",
      component: ParentsFindPassword,
    },
    {
      path: "/parents-set-password",
      name: "ParentsSetPassword",
      component: ParentsSetPassword,
    },
    {
      path: "/msu",
      name: "Home",
      component: Home,
      meta: { requiresAuth: true },
      redirect: {
        name: "HomePage",
      },
      children: [
        {
          path: "home",
          name: "HomePage",
          component: HomePage,
        },
        {
          path: "/disclaimer",
          name: "Disclaimer",
          component: DisclaimerPage,
        },
        {
          path: "english-central",
          name: "EnglishCentralPage",
          component: EnglishCentralPage,
        },
        {
          path: "iframe-display",
          name: "IframeDisplay",
          component: IframeDisplay,
        },
        // {
        //   path: "excel-chat",
        //   name: "ExcelChatPage",
        //   component: ExcelChatPage,
        // },
        {
          path: "class/",
          name: "Class",
          component: Class,
          redirect: {
            name: "ClassPage",
          },
          children: [
            {
              path: "class-page/:cid",
              name: "ClassPage",
              component: ClassPage,
            },
            {
              path: "class-book/:cid/:filter",
              name: "ClassBookPage",
              component: ClassBookPage,
            },
            {
              path: "class-video/:cid/:filter",
              name: "ClassVideoPage",
              component: ClassVideoPage,
            },
          ],
        },
        {
          path: "daily-goal/:class",
          name: "DailyGoal",
          component: DailyGoal,
        },
        {
          path: "daily-goal/book/:type/:did/:cid/:rid",
          name: "DailyBookDetail",
          component: CourseMaterialsBook,
        },
        {
          path: "daily-goal/video/:type/:did/:cid/:rid",
          name: "DailyVideoDetail",
          component: CourseMaterialsVideo,
        },
        {
          path: "daily-goal/oral/:type/:did/:cid/:rid",
          name: "DailyOralDetail",
          component: CourseMaterialsOral,
        },
        {
          path: "daily-login",
          name: "DailyLogin",
          component: DailyLogin,
        },
        {
          path: "practice-words",
          name: "PracticeWords",
          component: PracticeWords,
        },
        {
          path: "challenges",
          name: "Challenges",
          component: Challenges,
        },
        {
          path: "aispeech",
          name: "aispeech",
          component: AISpeech,
        },
        {
          path: "aispeech/content/:aiid/:aicid",
          name: "aispeechcontent",
          component: AISpeechContent,
        },
        {
          path: "aispeech/content/:aiid/:aicid/result",
          name: "AISpeechContentResult",
          component: AISpeechContentResult,
        },
        {
          path: "challenges/oral/:cname/:tid",
          name: "ChallengesOral",
          component: ChallengesOral,
        },
        {
          path: "challenges/oral/:cname/:tid/result",
          name: "ChallengesOralResult",
          component: ChallengesOralResult,
        },
        {
          path: "homework",
          name: "Homework",
          component: Homework,
        },
        {
          path: "homework/:aname/:cname/:tid/:aid",
          name: "HomeworkDetail",
          component: HomeworkDetail,
          meta: {
            homeworkName: "",
          },
        },
        {
          path: "course-materials-book/:type/:cid/:rid",
          name: "CourseMaterialsBook",
          component: CourseMaterialsBook,
        },
        {
          path: "course-materials-video/:type/:cid/:rid",
          name: "CourseMaterialsVideo",
          component: CourseMaterialsVideo,
        },
        {
          path: "course-materials-oral/:type/:cid/:rid/:asmgtid/:asgmt_mid",
          name: "CourseMaterialsOral",
          component: CourseMaterialsOral,
        },
        {
          path: "book-mark/:type/:cid/:rid",
          name: "BookMark",
          component: BookMark,
        },
        {
          path: "book-dictionary/:type/:cid/:rid",
          name: "BookDictionary",
          component: BookDictionary,
        },
        {
          path: "book-reading/:cid/:type/:page/:complete",
          name: "BookReading",
          component: BookReading,
        },
        {
          path: "quiz/:type/:typeid/:cid/:rid",
          name: "Quiz",
          component: Quiz,
        },
        {
          path: "quiz-result/:type/:typeid/:cid/:rid",
          name: "QuizResult",
          component: QuizResult,
        },
        {
          path: "quiz-revise/:type/:typeid/:cid/:rid",
          name: "QuizRevise",
          component: Quiz,
        },
        {
          path: "video-quiz/:type/:typeid/:cid/:rid",
          name: "VideoQuiz",
          component: VideoQuiz,
        },
        {
          path: "mangosteems-quiz/:type/:typeid/:cid/:rid",
          name: "QuizMangosteems",
          component: QuizMangosteems,
        },
        {
          path: "my-award",
          name: "MyAward",
          component: MyAward,
        },
        {
          path: "my-award-gacha",
          name: "MyAwardGacha",
          component: MyAwardGacha,
        },
        {
          path: "my-title",
          name: "MyTitle",
          component: MyTitle,
        },
        {
          path: "my-title-list/:tag",
          name: "MyTitleList",
          component: MyTitleList,
        },
        {
          path: "my-achievement",
          name: "MyAchievement",
          component: MyAchievement,
        },
        {
          path: "my-dictionary",
          name: "MyDictionary",
          component: MyDictionary,
        },
        {
          path: "level-check",
          name: "LevelCheck",
          component: LevelCheck,
        },
        {
          path: "daily-conversation",
          name: "DailyConversation",
          component: DailyConversation,
        },
        {
          path: "phrasal-verb",
          name: "PhrasalVerb",
          component: PhrasalVerb,
        },
        {
          path: "ai-bonus/:cid/:rid",
          name: "AIBonus",
          component: AIBonus,
        },
        {
          path: "gacha",
          name: "GachaPrize",
          component: GachaPrize,
          props: false,
          meta: { requiresAuth: true },
        },
        {
          path: "capsule-toy-land",
          name: "CapsuleToyLand",
          component: CapsuleToyLand,
        },
        {
          path: "reading-history",
          name: "ReadingHistory",
          component: ReadingHistory,
        },
      ],
    },
    {
      path: "/parents",
      name: "Parents",
      component: Parents,
      redirect: {
        name: "ParentsUiStudyStats",
      },
      children: [
        {
          path: "study-stats",
          name: "ParentsUiStudyStats",
          component: ParentsUiStudyStats,
        },
        {
          path: "std-account",
          name: "ParentsUiStdAccount",
          component: ParentsUiStdAccount,
        },
        {
          path: "history",
          name: "ParentsUiHistory",
          component: ParentsUiHistory,
        },
        {
          path: "award",
          name: "ParentsUiAward",
          component: ParentsUiAward,
        },
      ],
    },
    {
      path: "/404",
      name: "404",
      component: ErrorPage,
    },
    {
      path: "/auth-animation",
      name: "AuthAnimation",
      component: AuthAnimation,
    },
  ],
});
router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0);
  const global = useGlobalStore();

  // 設置標題文本（您現有的代碼）
  if (to.name === "HomePage") {
    global.$patch((state) => {
      state.lightHeaderText = "Home";
    });
  } else if (to.name === "Homework") {
    global.$patch((state) => {
      state.lightHeaderText = "Assignment";
    });
  } else if (to.name === "Challenges") {
    global.$patch((state) => {
      state.lightHeaderText = "Echo Valley";
    });
  } else if (to.name === "aispeech") {
    global.$patch((state) => {
      state.lightHeaderText = "AI Speech";
    });
  } else if (to.name === "DailyGoal") {
    global.$patch((state) => {
      state.lightHeaderText = "Daily Task";
    });
  } else if (to.name === "DailyLogin") {
    global.$patch((state) => {
      state.lightHeaderText = "Login Record";
    });
  } else if (to.name === "ReadingHistory") {
    global.$patch((state) => {
      state.lightHeaderText = "Reading History";
    });
  } else {
    global.$patch((state) => {
      state.lightHeaderText = "";
    });
  }

  // 檢查頁面是否需要授權
  if (to.meta.requiresAuth) {
    // 檢查用戶是否已登入
    const token = localStorage.getItem("token");
    if (!token) {
      // 用戶未登入，重定向到授權動畫頁面
      next({
        path: "/auth-animation",
        query: { redirect: to.fullPath },
      });
    } else {
      // 用戶已登入，正常通過
      next();
    }
  } else {
    // 不需要授權的頁面直接通過
    next();
  }
});
export default router;
